import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './core-ui/App';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/600.css';
import '@fontsource/roboto/700.css';
import { ServiceLayerProvider } from './core-ui/ServiceProvider';
export * from './IPlatformAPI';
export * from './utils';
export const init = (platformAPI) => {
    window.addEventListener('contextmenu', (e) => {
        e.preventDefault();
        e.stopPropagation();
    });
    const root = createRoot(document.getElementById('react-dom'));
    root.render(React.createElement(ServiceLayerProvider, { platformAPI: platformAPI, log: true },
        React.createElement(App, { platformAPI: platformAPI })));
};
//# sourceMappingURL=index.js.map